module.exports = __webpack_public_path__ + "static/media/nina-lose.d3f610e1.png";